jQuery(document).ready(function(){
    jQuery('.slick-section-slider').slick({
      mobileFirst: true,
      dots: true,
      dotsClass: 'slick-dots',
      responsive: [{
        breakpoint: 768,
        settings: {
          dots: true,
          dotsClass: 'slick-dots',
          arrows: true,
          centerPadding: '16px',
          draggable: false,
          centerMode: true,
          autoplay: true,
          autoplaySpeed: 3000,
          cssEase: 'ease',
          slidesToShow: 1,
          variableWidth: true,
          prevArrow: '<button type="button" data-role="none" class="slick-prev"><span class="ahoy-icon-arrow-long"></span></button>',
          nextArrow: '<button type="button" data-role="none" class="slick-next"><span class="ahoy-icon-arrow-long"></span></button>',
          customPaging: function(slider, i) {
              return '<button type="button" class="slick-pagi" data-role="none"></button>';
          },
        }
	  }, {
         breakpoint: 769,
         settings: 'unslick'
      }]
    });
});